// index.js
// Component for Home Page

// Imports
import React, { Component } from 'react';
import { Callout, Intent } from '@blueprintjs/core';
import dateFormat from 'dateformat';
import VersionLog from '../../data/VersionLog';
import './styles/style.css';

// Component Class
// Shows main page with version list and changelog
class MainView extends Component {
  // Renders Component
  render() {
    var versions = VersionLog.GetVersionData();
    versions.reverse();
    return (
      <div>
        <div className="App">
          <header className="App-header">
            <h1 className="App-title">Carlinhos</h1>
            <h1 className="App-title">Aplicativo de Gerenciamento de Compras</h1>
          </header>
          <br />
          <h4>Novidades</h4>
        </div>
        {versions.map((data, vId) =>
          <div key={vId}>
            <Callout title={"Versão "+data.version} intent={Intent.PRIMARY} icon="tick">
              {data.changelog.map((logData, lId) =>
                <div key={lId}>
                  <div><b>{dateFormat(logData.date, "dd/mm/yyyy")}</b></div>
                  {logData.changes.map((change, cId) =>
                    <li key={lId + "/" + cId}>{change}</li>
                  )}
                </div>
              )}
            </Callout>
            <br />
          </div>
        )}
      </div>
    );
  }
}

// Exports
export default MainView;



// WEBPACK FOOTER //
// ./src/components/MainView/index.js